<div class="landing">
  <div class="overlay">
    <h3>Welcome to Edenred Global Rewards Portal!</h3>
  </div>
</div>
